import React, { useState, useEffect, useRef } from "react";
import { FaWhatsapp, FaPhoneAlt, FaTimes } from "react-icons/fa";
import "../../assets/scss/floatingContact.scss";

const FloatingContacts = () => {
  const [openPopup, setOpenPopup] = useState(null); // "call" | "whatsapp" | null
  const popupRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setOpenPopup(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="floating-wrapper">
      {/* WhatsApp Floating Button */}
      <div
        className={`floating-btn whatsapp ${openPopup === "whatsapp" ? "active" : ""}`}
        onClick={() => setOpenPopup(openPopup === "whatsapp" ? null : "whatsapp")}
        aria-label="Chat on WhatsApp"
      >
        {openPopup === "whatsapp" ? <FaTimes /> : <FaWhatsapp />}
      </div>

      {/* Call Floating Button */}
      <div
        className={`floating-btn call ${openPopup === "call" ? "active" : ""}`}
        onClick={() => setOpenPopup(openPopup === "call" ? null : "call")}
        aria-label="Call Sadhvi Software Solutions"
      >
        {openPopup === "call" ? <FaTimes /> : <FaPhoneAlt />}
      </div>

      {/* Popup Container */}
      <div ref={popupRef}>
        {/* WhatsApp Popup */}
        {openPopup === "whatsapp" && (
          <div className="contact-popup whatsapp-popup">
            <h6>💬 Chat with Us</h6>
            <a
              href="https://wa.me/919092097333"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              +91 90920 97333
            </a>
          </div>
        )}

        {/* Call Popup */}
        {openPopup === "call" && (
          <div className="contact-popup call-popup">
            <h6>📞 Contact Us</h6>
            <a href="tel:+919092097333" className="contact-link">
              +91 90920 97333
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default FloatingContacts;
